module.exports = __webpack_public_path__ + "static/media/carousel5.d7003af0.png";